import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../redux/store'
import { CommonCare } from '../models/CommonCare'

export const retrieveCommonCares = createAsyncThunk<
  CommonCare[],
  void,
  ThunkConfig
>('simulation/retrieveCommonCares', async (_, { extra }) => {
  const commonCares = await extra.simulationGateway.fetchCommonCares()
  return commonCares
})
